package com.iregained.site.components.widgets.styles

import com.varabyte.kobweb.compose.css.Transition
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.boxShadow
import com.varabyte.kobweb.compose.ui.modifiers.transition
import com.varabyte.kobweb.compose.ui.modifiers.translateY
import com.varabyte.kobweb.silk.style.CssStyle
import com.varabyte.kobweb.silk.style.selectors.hover
import org.gstechnovos.jexonplastech.theme.toSitePalette
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.css.s

val SharedHeroImageStyle = CssStyle {
    val palette = colorMode.toSitePalette()

    base {
        // Slightly longer transition duration (0.4s) makes it feel "floaty" and expensive
        Modifier.transition(
            Transition.of("transform", 0.4.s), Transition.of("box-shadow", 0.4.s)
        ).boxShadow(
            offsetX = 0.px,
            offsetY = 10.px,
            blurRadius = 30.px,
            spreadRadius = (-5).px, // Pulls the base shadow in slightly so it doesn't look muddy
            color = palette.custom.darkText.toRgb().copyf(alpha = 0.1f)
        )
    }

    hover {
        Modifier.translateY((-8).px) // Lifts the image upward instead of scaling it outward
            .boxShadow(
                offsetX = 0.px, offsetY = 25.px, blurRadius = 40.px, spreadRadius = (-10).px,
                // UNIQUE TWIST: The shadow color shifts from gray to a glowing tint of your primary brand color!
                color = palette.brand.primaryBlue.toRgb().copyf(alpha = 0.25f)
            )
    }
}